import { hsv } from "d3-hsv";

export interface TawkColorsProvider {
  color1HorizontalSlider: string;
  color2StandardPill: string;
  color3TawkPillPortionAlreadyPlayed: string;
  color4PlaybackScrubber: string;
  color5TextBubble: string;
  color6TextItself: string;
}

export function tawksColorsWithCharacteristicHue(
  characteristicHue: number
): TawkColorsProvider {
  const characteristicHueInDegrees = characteristicHue * 360;

  return {
    color1HorizontalSlider: hsv(characteristicHueInDegrees, 0.04, 1).toString(),
    color2StandardPill: hsv(characteristicHueInDegrees, 0.14, 0.99).toString(),
    color3TawkPillPortionAlreadyPlayed: hsv(
      characteristicHueInDegrees,
      0.2,
      0.99
    ).toString(),
    color4PlaybackScrubber: hsv(
      characteristicHueInDegrees,
      0.28,
      0.97
    ).toString(),
    color5TextBubble: hsv(characteristicHueInDegrees, 0.04, 1).toString(),
    color6TextItself: "black",
  };
}
